// @mui
import { Stack, Typography } from '@mui/material';
// components
import SdgCountTile from 'src/components/SdgCountTile';
import GenericImpactMetric from 'src/components/impact/GenericImpactMetric';
import Title from 'src/components/reporting/Title';
// utils
import { formatNumber } from 'src/utils/numberFormatter';
import { carbonKilogramsToTrees } from 'src/utils/unitConverter';
// 
import { ISustainableDevelopmentGoal } from 'src/@types/basket';
import { ReportingTooltip } from 'src/@types/reporting';

// ----------------------------------------------------------------------

interface Props {
  totalMerchantImpact?: ReportingTooltip;
  listOfSDGs?: ISustainableDevelopmentGoal[];
}

const TotalImpactSection: React.FC<Props> = ({ totalMerchantImpact, listOfSDGs }) => {
  return (
    <Stack spacing={2}>
      <Title text="Total impact" />
      <Typography variant='body2'>
        Since the launch of your programme, you have facilitated{' '}
        <b>
          {formatNumber(totalMerchantImpact?.numberOfContributions)} individual
          contributions
        </b>{' '}
        and offset a total of{' '}
        <b>
          {formatNumber(totalMerchantImpact?.co2Kgs)} kg of carbon emissions
        </b>
        . That’s equivalent to the carbon absorbed by{' '}
        <b>{carbonKilogramsToTrees(totalMerchantImpact?.co2Kgs)} trees</b> in
        one year.
      </Typography>

      <Stack gap={{ xs: 3, sm: 6 }} justifyContent={'center'} direction={'row'} flexWrap={'wrap'}>
        <GenericImpactMetric
          loading={false}
          items={[
            {
              data: { value: totalMerchantImpact?.numberOfContributions },
              title: 'Total contributions',
              className: 'primary',
              key: 'CONTRIBUTIONS',
            },
            {
              data: { value: totalMerchantImpact?.co2Kgs, unit: 'kg' },
              title: 'Amount of carbon mitigiated',
              className: 'secondary',
              key: 'CARBON',
            },
          ]}
        />
        <SdgCountTile sdgCount={listOfSDGs?.length} />
      </Stack>
    </Stack>
  );
};

export default TotalImpactSection;
